import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

function DealDay(props) {
  const dealDay = [2, 3, 13, 18];
  const [view, setView] = useState(3);

  const handelView = (id) => {
    setView(id);
  };

  return (
    <div>
      <div className="mb-3">
        <div className="d-flex justify-content-center p-2">
          {props.products
            .filter((item, i) => item.id === view)
            .map((item) => {
              return (
                <div key={"a" + item.id} className="my_deal_img">
                  <img
                    className="img-fluid img-thumbnail mb-2"
                    src={item.image}
                    alt="..."
                  />
                  <div>
                    <span>{item.title}</span>
                    <p className="fw-bold h6 mt-1">
                      Rs.{item.discounted_price}{" "}
                      <span
                        className="text-decoration-line-through text-muted"
                        style={{ fontSize: "13px" }}
                      >
                        Rs.{item.selling_price}
                      </span>
                    </p>
                    <Link to={`/detail/${item.id}`}>
                      <Button variant="dark">View</Button>
                    </Link>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="d-flex">
        {props.products
          .filter((item) => {
            let show = false;
            dealDay.forEach((ditem) => {
              if (Number(ditem) === Number(item.id)) {
                show = true;
              }
            });
            return show;
          })
          .map((item, i) => {
            return (
              <div key={i} className="mx-2">
                <button
                  style={{ border: "none" }}
                  onClick={() => {
                    handelView(item.id);
                  }}
                >
                  <img
                    className="img-fluid img-thumbnail"
                    src={item.image}
                    alt="..."
                  />
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    products: state.products,
  };
};
export default connect(mapStateToProps)(DealDay);
